import React from "react";
import { Box, Typography, Grid, Divider, Container } from "@mui/material";
import { projectbannerbg } from "../../../../../assets";

interface Amenity {
  logo: string;
  h1: string;
}

interface AmenitiesProps {
  amenities: {
    d1: string;
    data: Amenity[];
  } | null;
}

const resolveImageUrl = (path: string) => {
  if (!path) return '';
  return path.startsWith('http') ? path : `${CDN_URL}${path}`;
};
const CDN_URL = process.env.NEXT_PUBLIC_STORAGE_DN_URL || 'https://dprstorage.b-cdn.net';


const Amenities: React.FC<AmenitiesProps> = ({ amenities }) => {
  const isValid = amenities && amenities.data && amenities.data.length > 0;

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        // height: isValid ? '100vh' : 'auto',
        backgroundImage: `url(${projectbannerbg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'bottom center',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        py: { xs: 0, md: 4 },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth='xl'>
        <Box
          sx={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            color: "#fff",
            px: 2,
            py: { xs: 4, md: 2 },
            height: "100%",
          }}
        >
          <Typography variant="h4" fontWeight={600} color="white"
          sx={{
            fontFamily: 'Futura,  sans-serif !important',
            letterSpacing:"2px"
          }}
          >
            AMENITIES
          </Typography>


          <Box
            sx={{
              width: {
                xs: "120px",
                md: "180px",
              },

              height: "2px",

              background:
                "linear-gradient(to right, transparent, #fff, transparent)",

              mx: "auto",

              mb: 2,
              mt:1
            }}
          />

          <Typography
            variant="body1"
            mx="auto"
            mb={6}
            sx={{ fontSize: "16px", color: 'white' }}
          >
            {isValid ? amenities.d1 : "Amenities data is not uploaded."}
          </Typography>

          {/* Grid shown only when valid */}
          {isValid && (
            <Grid
              container
              rowSpacing={2}
              columnSpacing={{
                xs: 1,
                md: 0.5,
              }}
              justifyContent="center"
              sx={{
                py: {
                  xs: 4,
                  md: 3,
                },

                maxWidth: "1250px",

                mx: "auto",
              }}
            >
              {amenities.data.map((item, index) => (
                <Grid item xs={4} sm={3} md={2} key={index}>
                  <Box
                    sx={{
                      display: "flex",

                      flexDirection: "column",

                      alignItems: "center",

                      justifyContent: "center",

                      textAlign: "center",

                      position: "relative",

                      transition: "0.4s ease",

                      cursor: "pointer",

                      "&:hover": {
                        transform: "translateY(-10px)",
                      },
                    }}
                  >
                    {/* ICON CIRCLE */}

                    <Box
                      sx={{
                        width: {
                          xs: 78,
                          md: 60,
                        },

                        height: {
                          xs: 78,
                          md: 60,
                        },

                        borderRadius: "50%",

                        display: "flex",

                        justifyContent: "center",

                        alignItems: "center",

                        position: "relative",

                        mb: 1.8,

                        background: "rgba(255,255,255,0.06)",

                        backdropFilter: "blur(10px)",

                        border: "1px solid rgba(255,255,255,0.12)",

                        transition: "0.4s ease",

                        "&::before": {
                          content: '""',

                          position: "absolute",

                          inset: "-8px",

                          borderRadius: "50%",

                          border: "1px solid rgba(255,255,255,0.08)",

                          opacity: 0,

                          transition: "0.4s ease",
                        },

                        "&:hover": {
                          background: "rgba(255,255,255,0.12)",

                          boxShadow:
                            "0 10px 35px rgba(255,255,255,0.12)",
                        },

                        "&:hover::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={resolveImageUrl(item.logo)}
                        alt={item.h1}
                        sx={{
                          width: {
                            xs: 34,
                            md: 28,
                          },

                          height: {
                            xs: 34,
                            md: 28,
                          },

                          objectFit: "contain",

                          filter: "brightness(0) invert(1)",
                        }}
                      />
                    </Box>

                    {/* TITLE */}

                    <Typography
                      variant="body2"
                      sx={{
                        color: "#fff",

                        fontSize: {
                          xs: "14px",
                          md: "14px",
                        },

                        fontWeight: 600,

                        letterSpacing: "0.5px",

                        transition: "0.3s ease",

                        "&:hover": {
                          color: "#d9d9d9",
                        },
                      }}
                    >
                      {item.h1}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default Amenities;
